import React from 'react';
import { ImageMinus } from 'lucide-react';
import { AnswerQualityHint } from './AnswerQualityHint';

interface Step10Data {
  image_elements_exclude: string;
}

interface Step10ImageElementsExcludeProps {
  data: Step10Data;
  onChange: (data: Step10Data) => void;
}

export function Step10ImageElementsExclude({ data, onChange }: Step10ImageElementsExcludeProps) {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
          <ImageMinus className="w-4 h-4" />
          Wat wil je juist vermijden in afbeeldingen?
        </label>
        <textarea
          value={data.image_elements_exclude}
          onChange={(e) => onChange({ ...data, image_elements_exclude: e.target.value })}
          rows={5}
          className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-lg resize-none"
          placeholder="Plastic verpakkingen, industriële ovens, fastfood, artificial lighting, steriele omgevingen, stockfoto mensen"
          autoFocus
        />
        <AnswerQualityHint length={data.image_elements_exclude.length} />
      </div>
    </div>
  );
}
